

import React, { useState, useEffect, useCallback } from 'react';

const Geotag_Employee_Popup = () => {

    const ALL_LOCATIONS = [
        { id: 1, name: 'Delhi Head Office', code: 'DEL-HO-01', zone: 'North', region: 'Delhi NCR', radius: 200, status: 'Active', address: 'Plot 14, Sector 44, Gurugram' },
        { id: 2, name: 'Delhi Tech Hub', code: 'DEL-TH-02', zone: 'North', region: 'Delhi NCR', radius: 300, status: 'Active', address: 'Tower B, Cyber City, DLF Phase 2' },
        { id: 3, name: 'Mumbai BKC Office', code: 'MUM-BK-01', zone: 'West', region: 'Mumbai', radius: 250, status: 'Active', address: 'G Block, Bandra Kurla Complex' },
        { id: 4, name: 'Pune Client Site', code: 'PUN-CS-01', zone: 'West', region: 'Pune', radius: 150, status: 'Active', address: 'Hinjewadi Phase 1, Pune' },
        { id: 5, name: 'Bangalore Embassy', code: 'BLR-EM-01', zone: 'South', region: 'Bangalore', radius: 400, status: 'Active', address: 'Embassy Golf Links, Bengaluru' },
        { id: 6, name: 'Hyderabad HITEC', code: 'HYD-HT-01', zone: 'South', region: 'Hyderabad', radius: 350, status: 'Active', address: 'HITEC City, Madhapur' },
        { id: 7, name: 'Kolkata Salt Lake', code: 'KOL-SL-01', zone: 'East', region: 'Kolkata', radius: 200, status: 'Inactive', address: 'Sector V, Salt Lake City' },
        { id: 8, name: 'Chennai OMR Zone', code: 'CHN-OM-01', zone: 'South', region: 'Chennai', radius: 300, status: 'Inactive', address: 'OMR, Sholinganallur, Chennai' },
    ];

    // State
    const [linkedIds, setLinkedIds] = useState(new Set([1]));
    const [pickerSelections, setPickerSelections] = useState(new Set([1]));
    const [filteredPickerLocs, setFilteredPickerLocs] = useState(ALL_LOCATIONS.filter(l => l.status === 'Active'));
    const [showGeoTagModal, setShowGeoTagModal] = useState(false);
    const [toast, setToast] = useState(null);

    // Show toast notification
    const showToast = useCallback((message, type = 'success') => {
        setToast({ message, type });
        setTimeout(() => setToast(null), 3000);
    }, []);

    // Filter location picker
    const filterLocPicker = useCallback(() => {
        const zoneEl = document.getElementById('locPickerZone');
        const regionEl = document.getElementById('locPickerRegion');
        const searchEl = document.getElementById('locPickerSearch');

        const zone = zoneEl?.value || '';
        const region = regionEl?.value || '';
        const q = (searchEl?.value || '').toLowerCase();

        const newFiltered = ALL_LOCATIONS.filter(l => {
            if (l.status !== 'Active') return false;
            if (zone && l.zone !== zone) return false;
            if (region && l.region !== region) return false;
            if (q && !l.name.toLowerCase().includes(q) && !l.address.toLowerCase().includes(q)) return false;
            return true;
        });

        setFilteredPickerLocs(newFiltered);
    }, []);

    // Toggle location selection
    const toggleLocSelection = useCallback((id) => {
        setPickerSelections(prev => {
            const newSet = new Set(prev);
            if (newSet.has(id)) newSet.delete(id);
            else newSet.add(id);
            return newSet;
        });
    }, []);

    // Save geo tag assignment
    const saveGeoTagAssignment = useCallback(() => {
        setLinkedIds(new Set(pickerSelections));
        setShowGeoTagModal(false);
        showToast('Geo tag locations updated successfully.');
    }, [pickerSelections, showToast]);

    // Unlink location
    const unlinkLocation = useCallback((id) => {
        setLinkedIds(prev => {
            const newSet = new Set(prev);
            newSet.delete(id);
            return newSet;
        });
        setPickerSelections(prev => {
            const newSet = new Set(prev);
            newSet.delete(id);
            return newSet;
        });
        showToast('Location removed from employee.', 'error');
    }, [showToast]);

    // Open modal
    const openGeoTagModal = useCallback(() => {
        setShowGeoTagModal(true);
        setPickerSelections(new Set(linkedIds));
        filterLocPicker();
    }, [linkedIds, filterLocPicker]);

    // Get linked locations
    const linkedLocations = ALL_LOCATIONS.filter(l => linkedIds.has(l.id));

    return (
        <div>
            <div className="page-inner">

                <div style={{fontSize:'.76rem', color:'var(--text-muted)', marginBottom:'1rem'}}>
                    <a href="#" style={{color:'var(--primary)', textDecoration:'none'}}>Employees</a>
                    <i className="fa fa-chevron-right" style={{fontSize:'.6rem', margin:'0 .4rem'}}></i>
                    <a href="#" style={{color:'var(--primary)', textDecoration:'none'}}>Rahul Singh</a>
                    <i className="fa fa-chevron-right" style={{fontSize:'.6rem', margin:'0 .4rem'}}></i>
                    Geo Tag Assignment
                </div>

                <div className="emp-detail-card">
                    <div className="emp-profile-strip">
                        <div className="emp-avatar-lg">RS</div>
                        <div>
                            <h3>Rahul Singh</h3>
                            <p>Engineering Lead &nbsp;·&nbsp; OG-003 &nbsp;·&nbsp; Delhi NCR &nbsp;·&nbsp; Joined 12 Mar 2021</p>
                        </div>
                        <div style={{marginLeft:'auto', display:'flex', gap:'.5rem'}}>
                            <button className="btn-og btn-og-secondary btn-og-sm"><i className="fa fa-envelope"></i> Message</button>
                            <button className="btn-og btn-og-primary btn-og-sm"><i className="fa fa-pencil"></i> Edit Profile</button>
                        </div>
                    </div>

                    <div className="detail-tabs">
                        <div className="detail-tab">Overview</div>
                        <div className="detail-tab">Personal Info</div>
                        <div className="detail-tab">Professional</div>
                        <div className="detail-tab active">Attendance</div>
                        <div className="detail-tab">Documents</div>
                        <div className="detail-tab">Payroll</div>
                    </div>

                    <div>
                        <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'1rem'}}>
                            <div>
                                <div style={{fontSize:'.95rem', fontWeight:700}}>Geo Tag Assignments</div>
                                <div style={{fontSize:'.78rem', color:'var(--text-muted)'}}>Locations where this employee can mark geo-tagged attendance from mobile</div>
                            </div>
                            <button className="btn-og btn-og-primary btn-og-sm" onClick={openGeoTagModal}>
                                <i className="fa fa-map-marker"></i> Assign Geo Tag Location
                            </button>
                        </div>

                        {linkedLocations.length > 0 ? (
                            <div style={{display:'flex', flexDirection:'column', gap:'.65rem', marginBottom:'1.25rem'}}>
                                {linkedLocations.map(loc => (
                                    <div className="linked-loc-card" key={loc.id}>
                                        <div className="loc-icon"><i className="fa fa-map-marker"></i></div>
                                        <div className="loc-info">
                                            <div className="loc-name">{loc.name}</div>
                                            <div className="loc-meta">
                                                <i className="fa fa-globe" style={{marginRight:'.25rem'}}></i>{loc.zone} · {loc.region}
                                                &nbsp;·&nbsp; <i className="fa fa-circle-o" style={{marginRight:'.2rem'}}></i>{loc.radius}m radius
                                                &nbsp;·&nbsp; <span style={{fontWeight:600}}>{loc.code}</span>
                                            </div>
                                        </div>
                                        <span className="status-pill pill-active" style={{flexShrink:0}}><i className="fa fa-circle" style={{fontSize:'.4rem'}}></i>Active</span>
                                        <button className="btn-og btn-og-danger btn-og-xs" onClick={() => unlinkLocation(loc.id)} title="Remove this location">
                                            <i className="fa fa-unlink"></i> Remove
                                        </button>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div style={{textAlign:'center', padding:'2rem', color:'var(--text-muted)', background:'#fafbfc', borderRadius:'10px', border:'2px dashed var(--border)', marginBottom:'1.25rem'}}>
                                <i className="fa fa-map-o" style={{fontSize:'2rem', marginBottom:'.5rem', display:'block', opacity:'.4'}}></i>
                                <div style={{fontWeight:600, marginBottom:'.3rem'}}>No geo tag location assigned</div>
                                <div style={{fontSize:'.78rem'}}>This employee will not be able to mark geo-tagged attendance until a location is assigned.</div>
                                <button className="btn-og btn-og-primary btn-og-sm" style={{marginTop:'.85rem'}} onClick={openGeoTagModal}>
                                    <i className="fa fa-plus"></i> Assign Location
                                </button>
                            </div>
                        )}

                        <div className="note-box">
                            <i className="fa fa-info-circle" style={{flexShrink:0, marginTop:'.1rem'}}></i>
                            <span>Multiple locations can be assigned to an employee (e.g. if they work across two offices). The employee's mobile app will allow check-in from any of the assigned locations within the defined radius.</span>
                        </div>
                    </div>
                </div>

            </div>

            {/* Toast Notification */}
            {toast && (
                <div style={{
                    position:'fixed',
                    bottom:'1.5rem',
                    right:'1.5rem',
                    background: toast.type === 'error' ? '#dc2626' : '#16a34a',
                    color:'#fff',
                    padding:'.75rem 1rem',
                    borderRadius:'8px',
                    boxShadow:'0 4px 12px rgba(0,0,0,.15)',
                    fontSize:'.78rem',
                    fontWeight:600,
                    zIndex:10000,
                    animation:'slideIn 0.3s ease-out'
                }}>
                    <i className="fa fa-check-circle" style={{marginRight:'.5rem'}}></i>
                    {toast.message}
                </div>
            )}

            {/* Geo Tag Modal */}
            {showGeoTagModal && (
                <div className={`og-modal-overlay${showGeoTagModal ? ' open' : ''}`} onClick={() => setShowGeoTagModal(false)}>
                    <div className="og-modal og-modal-lg" onClick={(e) => e.stopPropagation()}>
                        <div className="og-modal-header">
                            <i className="fa fa-map-marker" style={{color:'var(--primary)', fontSize:'1.1rem'}}></i>
                            <h5>Assign Geo Tag Location — Rahul Singh</h5>
                            <button className="modal-close" onClick={() => setShowGeoTagModal(false)}>
                                <i className="fa fa-times"></i>
                            </button>
                        </div>
                        <div className="og-modal-body">

                            <div style={{position:'relative', marginBottom:'1rem'}}>
                                <i className="fa fa-search" style={{position:'absolute', left:'.7rem', top:'50%', transform:'translateY(-50%)', color:'var(--text-muted)', fontSize:'.8rem'}}></i>
                                <input 
                                    type="text" 
                                    className="og-input" 
                                    id="locPickerSearch" 
                                    placeholder="Search locations…" 
                                    onInput={filterLocPicker} 
                                    style={{paddingLeft:'2.1rem'}} 
                                />
                            </div>

                            <div style={{display:'flex', gap:'.6rem', marginBottom:'1rem'}}>
                                <select className="og-select" id="locPickerZone" onChange={filterLocPicker} style={{minWidth:'130px'}}>
                                    <option value="">All Zones</option>
                                    <option value="North">North Zone</option>
                                    <option value="South">South Zone</option>
                                    <option value="East">East Zone</option>
                                    <option value="West">West Zone</option>
                                </select>
                                <select className="og-select" id="locPickerRegion" onChange={filterLocPicker} style={{minWidth:'140px'}}>
                                    <option value="">All Regions</option>
                                    <option value="Delhi NCR">Delhi NCR</option>
                                    <option value="Mumbai">Mumbai</option>
                                    <option value="Bangalore">Bangalore</option>
                                    <option value="Hyderabad">Hyderabad</option>
                                </select>
                                <span style={{fontSize:'.76rem', color:'var(--text-muted)', display:'flex', alignItems:'center', marginLeft:'auto'}}>
                                    <i className="fa fa-check-circle" style={{color:'var(--primary)', marginRight:'.3rem'}}></i>
                                    <span>{pickerSelections.size}</span> location(s) selected
                                </span>
                            </div>

                            <div style={{display:'flex', flexDirection:'column', gap:'.45rem', maxHeight:'340px', overflowY:'auto', paddingRight:'.25rem'}}>
                                {filteredPickerLocs.length === 0 ? (
                                    <div style={{textAlign:'center', padding:'2rem', color:'var(--text-muted)'}}>
                                        No active locations match filters
                                    </div>
                                ) : (
                                    filteredPickerLocs.map(loc => {
                                        const isSelected = pickerSelections.has(loc.id);
                                        return (
                                            <div 
                                                key={loc.id}
                                                className={`loc-picker-item${isSelected ? ' selected' : ''}`} 
                                                onClick={() => toggleLocSelection(loc.id)}
                                                style={{cursor:'pointer'}}
                                            >
                                                <div className="lpic-icon"><i className="fa fa-map-marker"></i></div>
                                                <div style={{flex:1}}>
                                                    <div className="lpic-name">{loc.name}</div>
                                                    <div className="lpic-meta">{loc.zone} · {loc.region} · {loc.radius}m radius · {loc.code}</div>
                                                    <div className="lpic-meta" style={{marginTop:'.1rem'}}><i className="fa fa-map-pin" style={{marginRight:'.25rem'}}></i>{loc.address}</div>
                                                </div>
                                                <div className="lpic-check">{isSelected ? <i className="fa fa-check"></i> : ''}</div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>

                            <div style={{marginTop:'1rem'}} className="note-box">
                                <i className="fa fa-lightbulb-o" style={{flexShrink:0, marginTop:'.1rem'}}></i>
                                <span>Select one or more locations. The employee can mark attendance from any selected location when within the defined geo-fence radius on their mobile app.</span>
                            </div>
                        </div>
                        <div className="og-modal-footer">
                            <button className="btn-og btn-og-secondary" onClick={() => setShowGeoTagModal(false)}>Cancel</button>
                            <button className="btn-og btn-og-primary" onClick={saveGeoTagAssignment}>
                                <i className="fa fa-save"></i> Save Assignment
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Geotag_Employee_Popup;